<template>
  <v-app>
    <v-app-bar flat color="primary" density="comfortable">
      <v-toolbar class="elevation-0 primary" density="comfortable">
        <v-btn
          color="success"
          variant="flat"
          @click="router.push('/' + (locale.value || 'pt') + '/backend')"
        >
          Ver artigos
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn color="secondary" variant="tonal" @click="logout">
          Logout
        </v-btn>
      </v-toolbar>
    </v-app-bar>

    <v-main>
      <v-container fluid class="ma-0 pa-0">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import LoginAPI from '@/api/User.js'

const router = useRouter()
const route = useRoute()
const { locale } = useI18n({ useScope: 'global' })

const selectedLanguage = ref(null)
const downloadFile = ref(false)

onMounted(() => {
  selectedLanguage.value = locale.value = route.params.lang
})

function downloadJsonFile () {
  downloadFile.value = true
}

function changeLanguage (c) {
  locale.value = c
}

function logout () {
  LoginAPI.logout(null)
    .then(() => {
      localStorage['auth_dreamdeal_website'] = 0
      router.push('/')
    })
    .catch(() => {
      // ignora erros silenciosamente
    })
}
</script>
